// extracted by mini-css-extract-plugin
module.exports = {"BankBalancePage":"index_BankBalancePage__3env1","headerCon":"index_headerCon__1YnI5","btnWords":"index_btnWords__1-Qzj"};